import { setCloseTimeout } from './set-close-timeout';
export const setStepName = (stepName) => (dispatch) => {
    dispatch({ type: 'TROUBLESHOOTING/SET_STEP_NAME', payload: stepName });
    if (!stepName) {
        dispatch(setCloseTimeout(null));
    }
};
